import React, { Suspense, useState, useEffect } from "react";
import projectServices from "./projectServices";
import ProjectSettingStatus from "./projectSettingStatus";
import commonServices from "../Common/commonServices";
import AffiliatePeriod from "../PeriodSelection/AffiliatePeriod";

export default function ProjectSummarySetting(param: any) {

    const [noEndDate, setNoEndDate] = useState(true);
    const [activeTab, setActiveTab] = useState('attributes');
    const [accountingPeriod, setAccountingPeriod] = useState(0);
    const [reportingEnds, setReportingEndPeriod] = useState('');
    var [projectMapData, setProjectMapData] = useState<any>([]);
    const [attributeList, initattributeList] = useState<any>([]);
    const [tagLookupTypes, setTagLookupTypes] = useState<any>([]);
    let [isContractModalOpen, setContractModalOpen] = useState(false);
    const [isProductModalOpen, setProductModalOpen] = useState(false);
    const [reportingFirstPeriod, setReportingFirstPeriod] = useState('');
    const [projectDescriptionList, setProjectDescriptionList] = useState<any>([]);
    const [excludedProductStatuses, setExcludedProductStatuses] = useState<[]>([]);
    const [excludedContractStatuses, setExcludedContractStatuses] = useState<[]>([]);

    const handleAccountingPeriodChange = (e: any) => { setAccountingPeriod(parseInt(e.target.value, 10)); };
    const handleReportingFirstPeriodChange = (e: any) => { setReportingFirstPeriod(e); };
    const handleReportingEndPeriodChange = (e: any) => { setReportingEndPeriod(e); };
    const handleNoEndDateChange = (e: any) => { setNoEndDate(e.target.checked); };


    const pickerColors = [
        '#EF534F', '#C62928', '#980A0B',
        '#BA69C8', '#7B1FA2', '#4A148C',
        '#FFD54F', '#F57C02', '#E65100',
        '#81C784', '#2F7D31', '#1A5E20',
        '#7FDEEA', '#00838F', '#004D41',
        '#90CAF9', '#029BE5', '#01579B',
        '#FFFFFF', '#DBDBDB', '#000000'
    ];

    useEffect(() => {
        changeTab('attributes')
    }, [param.project]);

    const projectSettingSave = () => {

        console.log(attributeList)
        projectServices.setProjectSettingsDetails(attributeList).then((res) => {
            attributeListing();
        });
    };

    const openProductModal = () => { setProductModalOpen(true); };
    const openContractModal = () => { isContractModalOpen = true; setContractModalOpen(isContractModalOpen); };


    const changeTab = (e: any) => {
        setActiveTab(e)
        if (e === 'attributes') {
            attributeListing();
        }
        if (e === 'Maps') {
            commonServices.getProjectMaps({ "projectId": param.project.projectId, "userId": "", "pageNumber": 1, "pageSize": 10, "excludeProject": 0, "currentProject": 1, "containerArea": "ProjectMap" }).then((data) => {
                setProjectMapData(data);
            });

        }
        if (e === 'Description') {
            projectServices.descriptionList({ "projectId": param.project.projectId, "pageNumber": 1, "pageSize": 10 }).then((data) => {
                setProjectDescriptionList(data);
            });
        }
    }

    const attributeListing = () => {
        projectServices.tagTypeList().then((data) => { setTagLookupTypes(data); })
        projectServices.attributeList({ "projectId": param.project.projectId }).then((res) => { initattributeList(res[0]) })
        projectServices.getExcludedContractStatus({ "referenceCode": param.project.projectId, "text": '', "pageNumber": 1, "pageSize": 10 }).then((data) => { setExcludedContractStatuses(data); })
        projectServices.getExcludedProductStatus({ "referenceCode": param.project.projectId, "text": '', "pageNumber": 1, "pageSize": 10 }).then((data) => { setExcludedProductStatuses(data); })
    }

    const removeContractTag = (tag: any) => {
        projectServices.removeProjectTag(tag.id).then((data) => {
            attributeListing();
        });
    };

    const removeProductTag = (tag: any) => {
        projectServices.removeProjectTag(tag.id).then((data) => {
            attributeListing();
        });
    };

    const updateAttribute = (fieldName: any, fieldValue: any) => { initattributeList((prev: any) => ({ ...prev, [fieldName]: fieldValue })) }

    const closeStatus = (e: any) => {
        setContractModalOpen(false)
        setProductModalOpen(false)
        changeTab('attributes');
    }

    const [formValues, setFormValues] = useState({
        projectId: param.project.projectId,
        description: '',
        isActive: true
    });

    const editProjectDescription = (e: any) => {
        //console.log(e)
        setFormValues(existingValues => ({ ...existingValues, description: e }));
    };

    const saveProjectDescription = () => {
        //console.log(formValues);
        projectServices.saveProjectDescription(formValues).then(() => {
            changeTab("Description")
        });
    };

    const onChangeDate = (e: any) => { console.log(e) }

    return (

        <>
            <div className="box">
                <div className="box-header">
                    <h2> Project settings</h2>

                </div>

                <div className="box-content">

                    <ul className="nav nav-tabs forceSingleLine">

                        <li className={activeTab === 'attributes' ? "nav-horizontal active" : "nav-horizontal"}
                            onClick={() => changeTab("attributes")}>Attributes</li>

                        <li className={activeTab === 'Accounting' ? "nav-horizontal active" : "nav-horizontal"}
                            onClick={() => changeTab("Accounting")}>Accounting  </li>

                        <li className={activeTab === 'Queue' ? "nav-horizontal active hide" : "nav-horizontal hide"}
                            onClick={() => changeTab("Queue")}>Queue Rules</li>

                        <li className={activeTab === 'Maps' ? "nav-horizontal active" : "nav-horizontal"}
                            onClick={() => changeTab("Maps")}>Project Maps </li>

                        <li className={activeTab === 'Description' ? "nav-horizontal active" : "nav-horizontal"}
                            onClick={() => changeTab("Description")}>Project Description</li>
                    </ul>

                    {activeTab === 'attributes' && (
                        <div className="ws-12">
                            <div className="ws-12">
                                <div className="box">
                                    <div className="box-header">
                                        <h2 className="pl">Set the project's relational association</h2>
                                    </div>
                                    <div className="box-content">
                                        <div className="ws-12">
                                            <div className="form-format">
                                                <label className="control-label ml">Primary Focus : </label>
                                                <div className="label-entries">
                                                    <ul className="nav nav-tabs ws-6">
                                                        <li className={!attributeList?.primaryFocus || attributeList?.primaryFocus === 'Contracts' ? "nav-horizontal mrl active" : "nav-horizontal mrl"}
                                                            onClick={() => updateAttribute("primaryFocus", 'Contracts')}> Contracts </li>
                                                        <li className={attributeList?.primaryFocus === 'Assets' ? "nav-horizontal mrl active" : "nav-horizontal mrl"}
                                                            onClick={() => updateAttribute("primaryFocus", 'Assets')}> Assets </li>
                                                    </ul>

                                                    <div className="ws-6 grey-text"> Focus on Contracts with all associated Assets or Asset with all associated Contracts </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ws-12 mt">
                                            <div className="form-format">
                                                <label className="control-label ml">Linking : </label>
                                                <div className="label-entries">
                                                    <ul className="nav nav-tabs ws-6">
                                                        <li className={!attributeList?.linking || attributeList?.linking === 'Hard' ? "nav-horizontal mrl active" : "nav-horizontal mrl"}
                                                            onClick={() => updateAttribute("linking", 'Hard')}> Hard </li>
                                                        <li className={attributeList?.linking === 'Soft' ? "nav-horizontal mrl active" : "nav-horizontal mrl"}
                                                            onClick={() => updateAttribute("linking", 'Soft')}> Soft </li>
                                                    </ul>
                                                    <div className="ws-6 grey-text"> Hard Linking is actual Contract or Asset Linked to Project. Soft Linking is all associated(excluding statuses) </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ws-12 mtl">
                                            <div className="form-format">
                                                <div className="label-entries">
                                                    <div className="ws-6">
                                                        <span className="ps pull-left text-bold">
                                                            <i className="icon-compose mr mt"
                                                                data-tip="Edit Contract Statuses to Exclude"
                                                                onClick={openContractModal} />
                                                            <span>Contract Statuses to Exclude:</span>
                                                        </span>

                                                    </div>
                                                    <div className="ws-6">
                                                        {excludedContractStatuses.map((contractStatus: any, index: any) => (
                                                            <a key={index} className="btn mb " style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{contractStatus.text}</span>
                                                                <span className="pull-right ws-2 mtss" onClick={() => removeContractTag(contractStatus)}>
                                                                    <i className="icon-cancel1 text-xl"></i>
                                                                </span>
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ws-12 mtl">
                                            <div className="form-format">
                                                <div className="label-entries">
                                                    <div className="ws-6">
                                                        <span className="ps pull-left text-bold">
                                                            <i className="icon-compose mr mt"
                                                                data-tip="Edit Product Statuses to Exclude"
                                                                onClick={openProductModal} />
                                                            <span>Product Statuses to Exclude:</span>
                                                        </span>
                                                    </div>
                                                    <div className="ws-6">
                                                        {excludedProductStatuses.map((productStatus: any, index: any) => (
                                                            <a key={index} className="btn mb " style={{ background: pickerColors[index], color: "#FFFFFF" }}>
                                                                <span className="ws-10 mt text-center" style={{ background: pickerColors[index], color: "#FFFFFF" }}>{productStatus.text}</span>
                                                                <span className="pull-right ws-2 mtss" onClick={() => removeProductTag(productStatus)}>
                                                                    <i className="icon-cancel1 text-xl"></i>
                                                                </span>
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="icon-btn edit pull-right" onClick={projectSettingSave}>
                                        <i className="icon-save"></i> Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}

                    {activeTab === 'Accounting' && (
                        <div className="ws-12">
                            <div className="pLarge">
                                <div className="ws-12 ptl">
                                    <div className="form-format ws-12">
                                        <label>Accounting Period</label>
                                        <div className="label-entries">
                                            <select value={attributeList?.accountingPeriod} onChange={handleAccountingPeriodChange}>
                                                <option value={0} label="Monthly">Monthly</option>
                                                <option value={1} label="Quarterly">Quarterly</option>
                                                <option value={2} label="Bi-Annually">Bi-Annually</option>
                                                <option value={3} label="Annually">Annually</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-12 ptl">
                                    <div className="form-format ws-12">
                                        <label>Reporting First Period</label>
                                        <div className="label-entries">
                                            <AffiliatePeriod onChange={handleReportingFirstPeriodChange} onChangeDate={onChangeDate}
                                                selectedPeriod={attributeList && attributeList.reportingFirstPeriod ? attributeList.reportingFirstPeriod : ""} />
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-12 ptl">
                                    <div className="form-format ws-12">
                                        <label>Reporting End Period</label>
                                        <AffiliatePeriod onChange={handleReportingEndPeriodChange} onChangeDate={onChangeDate}
                                            selectedPeriod={attributeList && attributeList.reportingEnds ? attributeList.reportingEnds : ""} />
                                    </div>
                                </div>

                                <div className="ws-12 ptl">
                                    <input key='noEndDate' type="checkbox" checked={attributeList?.noEndDate} onChange={handleNoEndDateChange} /> No End Date
                                </div>
                                <button className="icon-btn edit pull-right" onClick={projectSettingSave}>
                                    <i className="icon-save"></i> Save
                                </button>
                            </div>
                        </div>
                    )}

                    {activeTab === 'Queue' && (
                        <div className="ws-12">

                        </div>
                    )}

                    {activeTab === 'Maps' && (
                        <>
                            {(projectMapData.length === 0) && <div>
                                <div className="alert alert-info mt"> No records to display </div>
                                <a className="icon-btn edit mtl pull-right">Add new</a>
                            </div>}

                            {(projectMapData.length > 0) && <div>
                                <table className="ptl tableRounded">
                                    <thead>
                                        <tr>
                                            <th>Transaction Ref </th>
                                            <th>Description</th>
                                            <th> %</th>
                                            <th> Period</th>
                                            <th> </th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                    </tbody><tbody>
                                        {projectMapData?.map((value: any) => {

                                            return (
                                                <tr>
                                                    <td>{value.transaction_Ref}</td>
                                                    <td>{value.transaction_description}</td>
                                                    <td className="text-right">{value.trans_Percentage_amount}</td>
                                                    <td></td>
                                                    <td> <a className="icon-btn edit"><i className="icon-LPurple-Setting"></i></a></td>

                                                </tr>)
                                        })}

                                    </tbody>
                                </table>
                            </div>}


                        </>
                    )}

                    {activeTab === 'Description' && (
                        <div className="ws-12">
                            <div className="m1 p1">

                                <div className="ws-12 box">
                                    <div className="box-header"><h2>Project Description</h2> </div>
                                    <div className="ws-6 pll ptl">
                                        <div className="form-format">
                                            <label className="control-label">Project Id</label>
                                            <div className="label-entries">
                                                <input key='projectId' type="text"
                                                    name="projectId" disabled={true} readOnly
                                                    value={formValues.projectId} style={{ cursor: "not-allowed" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ws-6 ptl">
                                        <div className="form-format">
                                            <label className="control-label">Description*</label>
                                            <div className="label-entries">
                                                <input key='description' type="text"
                                                    name="description" onChange={(e) => { editProjectDescription(e.target.value) }}
                                                    value={formValues.description} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pull-right pbl mtxl">
                                        <button className="btn-s  icon-btn delete" > <i className="icon-refresh2"></i> Reset</button>
                                        <button className="btn-s icon-btn edit" onClick={() => saveProjectDescription()}> <i className="icon-save"></i> Save</button>
                                    </div>
                                </div>

                                <div className="box m1 ">
                                    <div className="box-header"><h2>{projectDescriptionList.length} record(s) found</h2> </div>
                                    <div className="ws-12 pLarge">
                                        {(projectDescriptionList.length > 0) && <table>
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>isActive</th>
                                                    <th>Operations</th>
                                                </tr>

                                            </thead>
                                            <tbody>
                                                {projectDescriptionList?.map((projectDescriptionItem: any) => (
                                                    <tr key={projectDescriptionItem.id}>
                                                        <td>{projectDescriptionItem.description}</td>
                                                        <td>{projectDescriptionItem.isActive}
                                                            <a data-tip="Set Default" className={"btn-xs ${projectDescriptionItem.isActive ? 'icon-btn edit' : 'btn-grey'}"} >
                                                                <i className="icon-checkmark3"></i>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <a data-tip="Edit" className="icon-btn edit caret" onClick={()=>editProjectDescription(projectDescriptionItem.description)}>
                                                                <i className="icon-edit-pencil"></i>
                                                            </a>

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>}

                                    </div>
                                </div>

                            </div>
                        </div>
                    )}
                </div>
            </div>
            {
                (() => {
                    if (isContractModalOpen) {
                        return (<ProjectSettingStatus open={isContractModalOpen} data={excludedContractStatuses} project={param.project} closeStatus={closeStatus} type="Contract" />)
                    }

                    if (isProductModalOpen) {
                        return (<ProjectSettingStatus open={isProductModalOpen} data={excludedProductStatuses} project={param.project} closeStatus={closeStatus} type="Product" />)
                    }

                })()
            }
        </>

    )
}
